import type { RoomOccupancy } from '@/domain/shared/types'
import { CHILDREN_MAX_AGE, CHILDREN_MIN_AGE } from '@/domain/shared/constants'
import { sub } from 'date-fns'

export function mapParticipants(birthdates: string[]): RoomOccupancy[] {
  const adultAgeThreshold = sub(new Date(), { years: CHILDREN_MAX_AGE, days: 1 })
  const childrenAgeThreshold = sub(new Date(), { years: CHILDREN_MIN_AGE, days: 1 })

  const participants: RoomOccupancy = {
    adults: 0,
    children: [],
    babies: [],
  }

  for (const birthdateStr of birthdates) {
    const birthdate = new Date(birthdateStr)

    if (birthdate < adultAgeThreshold) {
      participants.adults += 1
    }
    else if (birthdate < childrenAgeThreshold) {
      participants.children.push(birthdate)
    }
    else {
      participants.babies.push(birthdate)
    }
  }

  return [participants]
}
